export enum PasswordValidator {
  PASSWORD_IS_MANDATORY = 'password_is_mandatory',
  PASSWORD_IS_SHORT = 'password_is_short',
  PASSWORD_IS_WEAK = 'password_is_weak',
  PASSWORD_IS_TOO_LONG = 'password_is_too_long',
}

export const PASSWORD_MIN_LENGTH = 15;
export const PASSWORD_MAX_LENGTH = 128;
export const PASSWORD_COMPLEXITY = 3;

function getPasswordLength(password: string) {
  const segmenter = new Intl.Segmenter();
  let stringLength = 0;
  for (const _ of segmenter.segment(password)) {
    stringLength++;
  }
  return stringLength;
}

export function validatePassword(value: string): { error: PasswordValidator } | null {
  if (typeof value !== 'string' || String(value).trim().length === 0) {
    return {
      error: PasswordValidator.PASSWORD_IS_MANDATORY,
    };
  }

  if (getPasswordLength(value) < PASSWORD_MIN_LENGTH) {
    return {
      error: PasswordValidator.PASSWORD_IS_SHORT,
    };
  }

  if (getPasswordLength(value) > PASSWORD_MAX_LENGTH) {
    return {
      error: PasswordValidator.PASSWORD_IS_TOO_LONG,
    };
  }

  const hasLowerLettersRegexp = /[a-zа-я]/g;
  const hasUpperLettersRegexp = /[A-ZА-Я]/g;
  const hasNumbersRegexp = /[0-9]/g;

  const hasLowerLetters = Number(hasLowerLettersRegexp.test(value));
  const hasUpperLetters = Number(hasUpperLettersRegexp.test(value));
  const hasNumbers = Number(hasNumbersRegexp.test(value));

  if (hasLowerLetters + hasUpperLetters + hasNumbers >= PASSWORD_COMPLEXITY) {
    return null;
  }
  return {
    error: PasswordValidator.PASSWORD_IS_WEAK,
  };
}
